<template>
    <div class="rectangle-peak">
        <div class="portfolios-title-container">
            <span></span>
            <span class="name-container">Valores de mi cartera</span>
            <span class="close-container" @click="_emitCloseComponent">X</span>
        </div>
        <hr />
        <div class="portfolios-container">
            <div>
                <p class="name-portfolio-container"  @click="_redirectToWaitingsSearch()">Valores en espera</p>
                <p class="name-portfolio-container" @click="_redirectToOpenPositionsSearch()">Valores en cartera</p>
                <p class="name-portfolio-container" @click="_redirectToStockSearch()">Ver todos</p>
            </div>
        </div>
    </div>
</template>

<script>
    import APICaller from "@/components/codeComponents/APICaller.js";
    import { mapGetters } from "vuex";

    export default{
        mixins: [APICaller],
        name: "ValoresCartera",
        components:{
        },
        data: () =>({
            portfolios: [],
        }),
        created(){

        },
        watch: {
        },
        computed:{
            ...mapGetters(['_g_portfolio_id_selected'])
        },
        mounted(){
            this._getPortfolios()
        },
        methods:{
            _getPortfolios: function(){
                let success = (response) => {            
                    this.portfolios = response.data
                };
                let url = '/api/v1/portfolio/list';

                const successHandler = new APICaller.SuccessHandler(success);
                const failureHandler = new APICaller.FailureHandler('029.2', 'Error cargando las carteras de usuario.');

                this._getAPICall(url, successHandler, failureHandler);

            },
            _emitCloseComponent: function(){
                this.$emit("close-component")
            },
            _redirectToStockSearch: function(){
                this.$router.push('/app/graficador-dinamico/all-values/' + this._g_portfolio_id_selected);
            },
            _redirectToWaitingsSearch: function(){
                this.$router.push('/app/graficador-dinamico/waitings/' + this._g_portfolio_id_selected);
            },
            _redirectToOpenPositionsSearch: function(){
                this.$router.push('/app/graficador-dinamico/open-positions/' + this._g_portfolio_id_selected);
            },
        }
    }

</script>

<style>
.rectangle-peak {
    position: absolute;
    height: 225px;
    width: 320px;
    background: #F3F4F7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    top: 40%;
    left: 100px;
    border-radius: 10px;
    margin-top: 0 !important;
}

.rectangle-peak::before {
    border: 25px solid #F3F4F7;
    content: '';
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-top-color: transparent;
    position: absolute;
    left: -40px;
    top: 10px;
    border-radius: 10px;
}   
.portfolios-container{
    height: 400px;
    overflow-y: scroll;
}
.portfolios-title-container{
    height: 40px;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.name-container{
    font-weight: bold;
}
.close-container{
    font-weight: bold;
    margin-right: 10px;
    cursor: pointer;
}
.name-portfolio-container{
    margin-bottom: 30px;
    margin-left: 40px;
}
.name-portfolio-container:hover{
    cursor: pointer;
    color: rgb(14, 95, 133);
}
</style>